import { useLocation, useNavigate } from "react-router-dom";
import { Spiner } from "@components/loaders/spiner";
import {
  Bills,
  DaftarZiswaf,
  PaymentSavingSpp,
} from "@services/dtos/finance.dto";
import { FinanceService } from "@services/finance.service";
import { useThemeStore } from "@stores/theme.store";
import { useMutation, useQuery } from "@tanstack/react-query";
import { formatValue, toRp } from "@utils/helper";
import { Button, Form, Input, message, Select } from "antd";
import { useEffect, useState } from "react";
import moment from "moment";
import lodash from "lodash";
import { FcFinePrint } from "react-icons/fc";
import { SchoolService } from "@services/school.service";
import {
  PopupCustom,
  PopupError,
  PopupSuccess,
} from "@components/general/popup";
import { linkPage } from "@utils/router";
import { HomeService } from "@services/home.service";

export const RequestVaPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { setHeader, setBottomNavigation, setAppBar } = useThemeStore(
    (state) => state,
  );
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm();
  // const [nominalSpp, setNominalSpp] = useState<number>(0);
  const [valUangSaku, setValUangSaku] = useState<string>("");
  const [tipeVa, setTipeVa] = useState<string>("");
  const [paymentMethod, setPaymentMethod] = useState<"va" | "saving">("va");
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [showMessageText, setShowMessageText] = useState<string>("");
  const [popupPayment, setPopupPayment] = useState<boolean>(false);
  const [popupSuccess, setPopupSuccess] = useState<boolean>(false);
  const [popupError, setPopupError] = useState<boolean>(false);
  const [result, setResult] = useState<any>({});
  const [adminFee, setAdminFee] = useState<number>(3000);
  const [errorSavingMessage, setErrorSavingMessage] = useState<string>("");
  const [bills, setBills] = useState<
    { id: string; notes: string; amount: number; jenis: string }[]
  >([]);
  const [idxDisabledPayment, setIdxDisabledPayment] = useState<
    { index: number; id: string; amount: number }[]
  >([]);
  const [billZiswaf, setBillZiswaf] = useState<
    {
      id: string;
      keterangan: string;
      nominal: number;
      batasWaktu: Date;
      mode: string;
      opsi: string;
      qty: number;
    }[]
  >([]);

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data, isPending } = useQuery({
    queryKey: [FinanceService.queries.GET_FINANCE_BILLS_PAID_OF, nis],
    queryFn: () => FinanceService.billsPaidOf({ nis }),
  });

  const { data: dataZiswaf, isPending: isPendingZis } = useQuery({
    queryKey: [FinanceService.queries.GET_FINANCE_ZIS],
    queryFn: () => FinanceService.ziswafList(),
  });

  const { data: dataUangSaku } = useQuery({
    queryKey: [HomeService.queries.GET_BILLS_AND_BALANCES, nis],
    queryFn: () => HomeService.billsAndBalances({ nis }),
  });

  const dataBills = data?.data;
  // .filter((item) => item.jenis === state.tipe);

  const { mutate: mutateVA, isPending: isPendingPaymentVa } = useMutation({
    mutationFn: FinanceService.virtualAccountRequest,
    onSuccess: (response) => {
      if (response.success) {
        setResult(response.data);
        setPopupPayment(false);
        setPopupSuccess(true);
      } else {
        setPopupPayment(false);
        setPopupError(true);
      }
    },
    onError: (error: any) => {
      setShowMessage(true);
      setShowMessageText(error.message ?? "Internal Error");
    },
  });

  const { mutate: mutateZiswafVA, isPending: isPendingPaymentZiswafVa } =
    useMutation({
      mutationFn: FinanceService.virtualAccountRequestZiswaf,
      onSuccess: (response) => {
        if (response.success) {
          setResult(response.data);
          setPopupPayment(false);
          setPopupSuccess(true);
        } else {
          setPopupPayment(false);
          setPopupError(true);
        }
      },
      onError: (error: any) => {
        setShowMessage(true);
        setShowMessageText(error.message ?? "Internal Error");
      },
    });

  const { mutate: mutateSaving, isPending: isPendingPaymentSaving } =
    useMutation({
      mutationFn: FinanceService.paymentSavingRequest,
      onSuccess: (response) => {
        if (response.success) {
          setResult(response.data);
          setPopupPayment(false);
          setPopupSuccess(true);
        } else {
          setErrorSavingMessage(response.message);
          setPopupPayment(false);
          setPopupError(true);
        }
      },
      onError: (error: any) => {
        setShowMessage(true);
        setShowMessageText(error.message ?? "Internal Error");
      },
    });

  const [nominalNonSpp, setNominalNonSpp] = useState(
    (data?.data ?? []).length !== 0
      ? Array(
          data?.data?.length,
          // data?.data?.filter((item) => item.jenis === "sekali").length
        ).fill("")
      : [],
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    setAppBar({ title: "Transaksi", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Transaksi",
      image: false,
    });
    // setBottomNavigation(state.tagihan ? "hidden" : "home");
    setBottomNavigation("hidden");
  }, [setHeader, setBottomNavigation, setAppBar]);

  const onPayment = () => {
    if (state.tipe === "bill") {
      if (bills.length < 1 && valUangSaku === "") {
        setShowMessage(true);
        setShowMessageText("Isi minimal 1 pembayaran");
        return;
      }
    }
    if (state.tipe === "zis") {
      if (billZiswaf.length < 1) {
        setShowMessage(true);
        setShowMessageText("Isi minimal 1 pembayaran");
        return;
      }
    }
    if (tipeVa === "" && paymentMethod === "va") {
      setShowMessage(true);
      setShowMessageText("Pilih rekening Bank terlebih dahulu");
      return;
    }
    if (
      (state.tipe === "topup" && valUangSaku === "") ||
      parseInt(valUangSaku.replace(/\./g, "")) < 10000
    ) {
      setShowMessage(true);
      setShowMessageText("Top-up Uang Saku minimal Rp. 10.000");
      return;
    }
    setPopupPayment(true);
  };

  const onConfirmPayment = () => {
    if (paymentMethod === "va" && state.tipe === "zis") {
      mutateZiswafVA({
        nis: nis,
        data_ziswaf: billZiswaf.map((item) => ({
          id_ziswaf: item.id,
          nominal: item.nominal,
          qty: item.qty,
        })),
      });
    } else if (paymentMethod === "va" && state.tipe !== "zis") {
      mutateVA({
        nis: nis,
        bank: tipeVa,
        uangsakumasuk:
          valUangSaku === "" ? "0" : valUangSaku.replace(/\./g, ""),
        data: bills.map((item) => ({
          id_tagihan: item.id,
          tagihan: item.notes,
          dibayar: item.amount.toString(),
        })),
        // data: {
        //   spp: bills
        //     .filter((item) => item.jenis === "bulanan")
        //     .map((item) => item.notes)
        //     .join(";"),
        //   daftarulang:
        //     bills.find((item) => item.notes === "Daftar Ulang")?.amount ?? 0,
        //   uangpangkal:
        //     bills.find((item) => item.notes === "Uang Pangkal")?.amount ?? 0,
        //   uangsakumasuk:
        //     valUangSaku === "" ? 0 : parseInt(valUangSaku.replace(/\./g, "")),
        // },
      });
    } else if (paymentMethod === "saving" && state.tipe !== "zis") {
      const today = new Date().toLocaleDateString("en-CA", {
        timeZone: "Asia/Jakarta",
      });
      const validMonths: (keyof PaymentSavingSpp)[] = [
        "januari",
        "februari",
        "maret",
        "april",
        "mei",
        "juni",
        "juli",
        "agustus",
        "september",
        "oktober",
        "november",
        "desember",
      ];

      const sppValues = bills
        .filter((item) => item.jenis === "bulanan")
        .reduce<Partial<PaymentSavingSpp>>((acc, item) => {
          const key = item.notes.toLowerCase() as keyof PaymentSavingSpp;
          if (validMonths.includes(key)) {
            acc[key] = item.amount ?? 0;
          }
          return acc;
        }, {});

      mutateSaving({
        nis: nis,
        tanggal: today,
        catatan: "Pembayaran via Tabungan",
        transfer: "UANGSAKU",
        data: bills.map((item) => ({
          nourut: item.id,
          tagihan: item.notes,
          dibayar: item.amount.toString(),
        })),
        // nis: nis,
        // transfer: "CASH",
        // tanggal: today,
        // data: {
        //   bimbel: bills.find((item) => item.notes === "Bimbel")?.amount ?? 0,
        //   daftarulang:
        //     bills.find((item) => item.notes === "Daftar Ulang")?.amount ?? 0,
        //   infaq: bills.find((item) => item.notes === "Infaq")?.amount ?? 0,
        //   uangpangkal:
        //     bills.find((item) => item.notes === "Uang Pangkal")?.amount ?? 0,
        //   uangsakumasuk:
        //     valUangSaku === "" ? 0 : parseInt(valUangSaku.replace(/\./g, "")),
        // },
        // spp: sppValues,
        // catatan: "",
        // keteranganinfaq: "",
      });
    }
  };

  const onChangeBill = (val: string, bill: Bills) => {
    const current = bills.filter((item) => item.id !== bill.nourut);

    if (bill.jenis === "bulanan") {
      onDisabledPayment(val, bill.nourut);
    }

    if (val === "") {
      bill.jenis === "bulanan"
        ? onDisabledPayment(val, bill.nourut)
        : setBills(current);

      return;
    }

    setBills(
      current.concat({
        id: bill.nourut,
        notes: bill.tagihan,
        amount: parseInt(val),
        // tempo: moment(bill.jatuhTempo).toDate(),
        jenis: bill.jenis,
      }),
    );
  };

  const onChangeBillZiswaf = (val: string, dataZiswaf: DaftarZiswaf) => {
    let nominal = 0;
    let qty = 0;
    const current = billZiswaf.filter((item) => item.id !== dataZiswaf.id);

    if (val === "") {
      setBillZiswaf(current);
      return;
    }

    if (dataZiswaf.opsi === "OPTIONAL") {
      nominal += parseInt(val) * dataZiswaf.nominal;
      qty += parseInt(val);
    } else {
      nominal += parseInt(val);
      qty = 1;
    }

    setBillZiswaf(
      current.concat({
        id: dataZiswaf.id,
        keterangan: dataZiswaf.keterangan,
        nominal: nominal,
        batasWaktu: moment(dataZiswaf.batasWaktu, "YYYY-MM-DD").toDate(),
        mode: dataZiswaf.mode,
        opsi: dataZiswaf.opsi,
        qty: qty,
      }),
    );
  };

  const checkData =
    data?.data
      ?.filter((item) => item.jenis === "bulanan")
      .map((item, index) => ({
        index: index,
        id: item.nourut,
        amount: item.nominal,
      })) ?? [];

  const onDisabledPayment = (val: string, nourut: string) => {
    const nourutIndex = checkData.findIndex((item) => item.id === nourut);
    if (
      val !== "" &&
      nourutIndex !== -1 &&
      nourutIndex < checkData.length - 1
    ) {
      const dataDisabled = [...idxDisabledPayment, checkData[nourutIndex + 1]];
      const uniqueElements = lodash.uniqBy(dataDisabled, "id");

      setIdxDisabledPayment(uniqueElements);
    } else if (val === "" || val === null || val === undefined) {
      const updatedData = idxDisabledPayment.filter(
        (item) => item.index <= nourutIndex,
      );
      const billsIndex = bills.findIndex((item) => item.id === nourut);

      if (billsIndex !== -1 && billsIndex < bills.length) {
        const updatedBills = bills.filter((item, index) => {
          return index < billsIndex || !(item.jenis === "bulanan");
        });
        setBills(updatedBills);
      }
      setIdxDisabledPayment(updatedData);
    }
  };

  const checkFirstIndexArr = (nourut: string) => {
    const currentArr = data?.data?.filter((item) => item.jenis === "bulanan");
    return (
      currentArr && currentArr.length > 0 && currentArr[0].nourut === nourut
    );
  };

  useEffect(() => {
    if (checkData.length > 0) {
      setIdxDisabledPayment([
        {
          index: checkData[0].index,
          id: checkData[0].id,
          amount: checkData[0].amount,
        },
      ]);
    }
  }, [data]);

  useEffect(() => {
    if (showMessage) {
      messageApi.open({
        type: "warning",
        content: <>{showMessageText}</>,
      });
    }
    setShowMessage(false);
  }, [showMessage, showMessageText, messageApi]);

  return (
    <>
      {contextHolder}
      <div className="tw-px-4 tw-pb-20">
        <Form form={form} className="tw-mb-4" name="basic" layout="vertical">
          {state.tipe === "bill" && (
            <div className="tw-mt-2 card-body">
              <div className="tw-mb-2 tw-text-xs tw-text-text-secondary">
                Pilih Metode Bayar
              </div>
              <Select
                className="tw-w-full"
                value={paymentMethod}
                options={[
                  { value: "va", label: "Virtual Account (VA)" },
                  {
                    value: "saving",
                    label: `Uang Saku (${toRp(
                      dataUangSaku?.data?.saldo ?? 0,
                    )})`,
                  },
                ]}
                onChange={(newValue) => {
                  setPaymentMethod(newValue);
                }}
              />
            </div>
          )}

          {state.tagihan && state.tipe === "bill" && (
            <>
              {/* tagihan */}
              <div className="tw-mt-4 tw-mb-4 tw-p-0 card-body">
                {isPending ? (
                  <div className="tw-text-center tw-p-4">
                    <Spiner />
                  </div>
                ) : dataBills != null && dataBills.length > 0 ? (
                  dataBills
                    // .filter((item) => item.jenis === "bulanan")
                    .map((item, idx) => (
                      <div
                        key={idx}
                        className="tw-p-2 tw-border-primary tagihan-wrapper"
                        style={{ borderBottom: "1px solid" }}
                      >
                        <div className="tw-px-2 tw-py-1">
                          <div className="tw-mb-2 tw-flex tw-justify-between tw-text-xs">
                            <div
                              className="tw-text-text-primary"
                              style={{
                                overflowWrap: "break-word",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "65%",
                              }}
                            >
                              {item.jenis === "bulanan"
                                ? `SPP ${item.tagihan}`
                                : item.tagihan}
                            </div>
                            <div className="tw-text-xs tw-text-text-secondary">
                              Bayar (Rp.)
                            </div>
                          </div>
                          <div className="tw-flex tw-justify-between tw-items-end tw-font-bold tw-text-text-primary">
                            <div className="tw-text-xs">
                              {toRp(item.nominal)}
                            </div>
                            {item.jenis === "bulanan" ? (
                              <Form.Item name="bayarspp" className="tw-mb-0">
                                <div className="tw-text-text-secondary">
                                  <Input
                                    style={{ width: "90%", float: "right" }}
                                    className="tw-text-right"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    type="text"
                                    value={
                                      idxDisabledPayment.some(
                                        (disabledItem) =>
                                          disabledItem.id === item.nourut,
                                      )
                                        ? formatValue(
                                            (
                                              bills.find(
                                                (i) => i.id === item.nourut,
                                              )?.amount ?? ""
                                            )
                                              ?.toString()
                                              .replace(/\D/g, ""),
                                          )
                                        : ""
                                    }
                                    onClick={(e) => {
                                      const input =
                                        e.target as HTMLInputElement;

                                      input.value =
                                        input.value === ""
                                          ? formatValue(
                                              item.nominal
                                                .toString()
                                                .replace(/\D/g, ""),
                                            )
                                          : "";

                                      onChangeBill(
                                        input.value
                                          .toString()
                                          .replace(/\D/g, ""),
                                        item,
                                      );
                                    }}
                                    onKeyDown={(event) => {
                                      if (
                                        !/[0-9]|Backspace|Tab/.test(event.key)
                                      ) {
                                        event.preventDefault();
                                      }
                                    }}
                                    disabled={
                                      (checkFirstIndexArr(item.nourut) &&
                                        idxDisabledPayment.length === 0) ||
                                      idxDisabledPayment.some(
                                        (disabledItem) =>
                                          disabledItem.id === item.nourut,
                                      )
                                        ? false
                                        : true
                                    }
                                    readOnly
                                  />
                                </div>
                              </Form.Item>
                            ) : (
                              <Form.Item name="bayarspp" className="tw-mb-0">
                                <div className="tw-text-text-secondary">
                                  <Input
                                    style={{ width: "90%", float: "right" }}
                                    className="tw-text-right"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    type="text"
                                    value={nominalNonSpp[idx]}
                                    onInput={(e) => {
                                      const input =
                                        e.target as HTMLInputElement;
                                      const raw = input.value.replace(
                                        /\D/g,
                                        "",
                                      );
                                      const clampedValue =
                                        raw === ""
                                          ? ""
                                          : Math.min(
                                              parseInt(raw),
                                              item.nominal,
                                            );
                                      const formatted = formatValue(
                                        clampedValue.toString(),
                                      );

                                      setNominalNonSpp((prevValues) => {
                                        const newValues = [...prevValues];
                                        newValues[idx] = formatted;
                                        return newValues;
                                      });
                                      onChangeBill(
                                        clampedValue.toString(),
                                        item,
                                      );
                                    }}
                                    onBlur={(e) => {
                                      const input =
                                        e.target as HTMLInputElement;
                                      const raw = input.value.replace(
                                        /\D/g,
                                        "",
                                      );
                                      const clampedValue =
                                        raw === ""
                                          ? ""
                                          : Math.min(
                                              parseInt(raw),
                                              item.nominal,
                                            );
                                      const formatted = formatValue(
                                        clampedValue.toString(),
                                      );

                                      setNominalNonSpp((prevValues) => {
                                        const newValues = [...prevValues];
                                        newValues[idx] = formatted;
                                        return newValues;
                                      });
                                    }}
                                    onKeyDown={(event) => {
                                      if (
                                        !/[0-9]|Backspace|Tab/.test(event.key)
                                      ) {
                                        event.preventDefault();
                                      }
                                    }}
                                  />
                                </div>
                              </Form.Item>
                            )}
                          </div>
                        </div>
                      </div>
                    ))
                ) : (
                  <div className="tw-text-center tw-p-8">
                    <FcFinePrint size={50} />
                    <div>Tidak ada tagihan</div>
                  </div>
                )}
              </div>

              {/* uang saku */}
              {paymentMethod === "va" && (
                <div className="tw-mb-4 tw-py-3 card-body">
                  <div className="tw-mb-2 tw-flex tw-justify-between tw-text-xs tw-text-text-primary">
                    <div>Uang Saku</div>
                  </div>
                  <div className="tw-flex tw-justify-between tw-items-end tw-font-bold">
                    <div className="tw-text-xs tw-text-text-primary">
                      (ketik nominal)
                    </div>
                    <Form.Item name="uangsaku" className="tw-mb-0">
                      <Input
                        style={{ width: "90%", float: "right" }}
                        className="tw-text-end"
                        inputMode="numeric"
                        type="text"
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");
                          const formattedValue = formatValue(value);
                          form.setFieldsValue({ uangsaku: formattedValue });
                          setValUangSaku(value === "" ? "" : formattedValue);
                        }}
                        onKeyDown={(event) => {
                          if (!/[0-9]|Backspace|Tab/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        value={valUangSaku}
                      />
                    </Form.Item>
                  </div>
                </div>
              )}
            </>
          )}

          {!state.tagihan && state.tipe === "zis" && (
            <div
              className="tw-mt-4 tw-mb-4 tw-p-0 card-body"
              // style={{
              //   boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)",
              // }}
            >
              {isPendingZis ? (
                <div className="tw-p-6 tw-text-center tw-p-4">
                  <Spiner />
                </div>
              ) : dataZiswaf?.data != null && dataZiswaf.data.length > 0 ? (
                dataZiswaf.data.map(
                  (item, idx) =>
                    item.batasWaktu === "" ||
                    (item.batasWaktu !== "" &&
                      moment().format("YYYY-MM-DD") <=
                        moment(item.batasWaktu).format("YYYY-MM-DD") && (
                        <div
                          key={idx}
                          className="tw-p-2 tw-border-primary tagihan-wrapper"
                          style={{ borderBottom: "1px solid" }}
                        >
                          <div className="tw-px-2 tw-py-1">
                            <div className="tw-mb-2 tw-flex tw-justify-between tw-text-xs">
                              <div
                                className="tw-text-text-primary"
                                style={{
                                  overflowWrap: "break-word",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "65%",
                                }}
                              >
                                {item.keterangan}
                              </div>
                              <div className="tw-text-xs tw-text-text-secondary">
                                Bayar (Rp.)
                              </div>
                            </div>
                            <div className="tw-flex tw-justify-between tw-items-end tw-font-bold tw-text-text-primary">
                              <div className="tw-text-xs">
                                {item.nominal.toString() === "0"
                                  ? "ketik nominal"
                                  : toRp(item.nominal)}
                              </div>
                              <Form.Item name="bayarspp" className="tw-mb-0">
                                <div className="tw-text-text-secondary">
                                  {item.nominal.toString() === "0" ? (
                                    <Input
                                      style={{
                                        width: "90%",
                                        float: "right",
                                      }}
                                      className="tw-text-right"
                                      inputMode="numeric"
                                      pattern="[0-9]*"
                                      type="text"
                                      value={nominalNonSpp[idx]}
                                      onInput={(e) => {
                                        const input =
                                          e.target as HTMLInputElement;
                                        const raw = input.value.replace(
                                          /\D/g,
                                          "",
                                        );
                                        const formatted = formatValue(
                                          raw.toString(),
                                        );

                                        setNominalNonSpp((prevValues) => {
                                          const newValues = [...prevValues];
                                          newValues[idx] = formatted;
                                          return newValues;
                                        });
                                        onChangeBillZiswaf(raw, item);
                                      }}
                                      onBlur={(e) => {
                                        const input =
                                          e.target as HTMLInputElement;
                                        const raw = input.value.replace(
                                          /\D/g,
                                          "",
                                        );

                                        const formatted = formatValue(
                                          raw.toString(),
                                        );

                                        setNominalNonSpp((prevValues) => {
                                          const newValues = [...prevValues];
                                          newValues[idx] = formatted;
                                          return newValues;
                                        });
                                      }}
                                      onKeyDown={(event) => {
                                        if (
                                          !/[0-9]|Backspace|Tab/.test(event.key)
                                        ) {
                                          event.preventDefault();
                                        }
                                      }}
                                    />
                                  ) : (
                                    <Input
                                      style={{
                                        width: "90%",
                                        float: "right",
                                      }}
                                      className="tw-text-right"
                                      inputMode="numeric"
                                      pattern="[0-9]*"
                                      type="text"
                                      value={formatValue(
                                        (
                                          billZiswaf.find(
                                            (i) => i.id === item.id,
                                          )?.nominal ?? ""
                                        )
                                          ?.toString()
                                          .replace(/\D/g, ""),
                                      )}
                                      onClick={(e) => {
                                        const input =
                                          e.target as HTMLInputElement;
                                        // const value = item.nominal
                                        //   .toString()
                                        //   .replace(/\D/g, "");

                                        input.value =
                                          input.value === ""
                                            ? formatValue(
                                                item.nominal
                                                  .toString()
                                                  .replace(/\D/g, ""),
                                              )
                                            : "";

                                        onChangeBillZiswaf(
                                          input.value
                                            .toString()
                                            .replace(/\D/g, ""),
                                          item,
                                        );
                                      }}
                                      onKeyDown={(event) => {
                                        if (
                                          !/[0-9]|Backspace|Tab/.test(event.key)
                                        ) {
                                          event.preventDefault();
                                        }
                                      }}
                                      readOnly
                                    />
                                  )}
                                </div>
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                      )),
                )
              ) : (
                <div className="tw-text-center tw-p-8">
                  <FcFinePrint size={50} />
                  <div>Tidak ada ZIS</div>
                </div>
              )}
            </div>
          )}

          {!state.tagihan && state.tipe === "topup" && (
            <div className="tw-mb-4 tw-py-3 card-body">
              <div className="tw-mb-2 tw-flex tw-justify-between tw-text-xs tw-text-text-primary">
                <div>Uang Saku</div>
              </div>
              <div className="tw-flex tw-justify-between tw-items-end tw-font-bold">
                <div className="tw-text-xs tw-text-text-primary">
                  (ketik nominal)
                </div>
                <Form.Item name="uangsaku" className="tw-mb-0">
                  <Input
                    style={{ width: "90%", float: "right" }}
                    className="tw-text-end"
                    inputMode="numeric"
                    type="text"
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      const formattedValue = formatValue(value);
                      form.setFieldsValue({ uangsaku: formattedValue });
                      setValUangSaku(value === "" ? "" : formattedValue);
                    }}
                    onKeyDown={(event) => {
                      if (!/[0-9]|Backspace|Tab/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    value={valUangSaku}
                  />
                </Form.Item>
              </div>
            </div>
          )}

          {paymentMethod === "va" && (
            <div className=" tw-mt-4 card-body">
              <div className="tw-mb-2 tw-text-xs tw-text-text-secondary">
                Pilih Bank
              </div>
              <Select
                className="tw-w-full"
                value={tipeVa}
                options={[
                  { value: "", label: "pilih bank", disabled: true },
                  { value: "BNI", label: "BNI" },
                  { value: "BSI", label: "BSI" },
                ]}
                onChange={(newValue) => {
                  setTipeVa(newValue);
                  setAdminFee(newValue === "BSI" ? 2500 : 3000);
                }}
              />
            </div>
          )}

          <Button
            type="primary"
            loading={isPendingPaymentVa}
            className="tw-p-2 tw-mt-8 tw-h-10 tw-w-full tw-text-base tw-rounded-xl bg-gradient tw-text-background-200 focus:tw-shadow-none hover:tw-bg-background-200 hover:tw-text-accent-primary hover:tw-border-primary"
            onClick={onPayment}
          >
            Lakukan Pembayaran
          </Button>
        </Form>
      </div>

      <PopupCustom
        open={popupPayment}
        title="Konfirmasi Pembayaran"
        onCancel={() => setPopupPayment(false)}
      >
        <>
          {valUangSaku !== "" ? (
            <>
              <div className="tw-my-3 divider"></div>
              <div className="tw-font-bold tw-mt-2 tw-mb-1 tw-text-text-primary">
                Uang Saku
              </div>
              <div className="tw-flex">
                <div className="tw-grow tw-text-text-secondary">Uang Saku</div>
                <div>
                  {valUangSaku === ""
                    ? toRp(0)
                    : toRp(parseInt(valUangSaku.replace(/\D/g, "")))}
                </div>
              </div>
            </>
          ) : null}

          {bills.length > 0 ? (
            <>
              <div className="tw-my-3 divider"></div>
              <div className="tw-font-bold tw-mt-2 tw-mb-1 tw-text-text-primary">
                Tagihan
              </div>
              {bills.map((item, idx) => (
                <div key={idx} className="tw-flex tw-justify-between tw-mb-0.5">
                  <div
                    className="tw-grow tw-text-text-secondary"
                    style={{ maxWidth: "50%" }}
                  >
                    {item.notes}
                  </div>
                  <div>{toRp(item.amount)}</div>
                </div>
              ))}
            </>
          ) : billZiswaf.length > 0 ? (
            <>
              <div className="tw-my-3 divider"></div>
              <div className="tw-font-bold tw-mt-2 tw-mb-1">Pembayaran</div>
              {billZiswaf.map((item, idx) => (
                <div key={idx} className="tw-flex tw-justify-between tw-mb-0.5">
                  <div className="tw-grow" style={{ maxWidth: "50%" }}>
                    {item.keterangan}
                  </div>
                  <div>{toRp(item.nominal)}</div>
                </div>
              ))}
            </>
          ) : null}
          <div className="tw-my-3 divider"></div>
          {paymentMethod === "va" && (
            <>
              <div className="tw-flex">
                <div className="tw-grow tw-text-text-secondary">Subtotal</div>
                <div>
                  {toRp(
                    bills.map((i) => i.amount).reduce((a, b) => a + b, 0) +
                      (valUangSaku === ""
                        ? 0
                        : parseInt(valUangSaku.replace(/\D/g, ""))) +
                      billZiswaf
                        .map((i) => i.nominal)
                        .reduce((a, b) => a + b, 0),
                  )}
                </div>
              </div>
              <div className="tw-flex">
                <div className="tw-grow tw-text-text-secondary">
                  Biaya Admin
                </div>
                <div>{toRp(adminFee)}</div>
              </div>
            </>
          )}
          <div className="tw-flex tw-mt-2">
            <div className="tw-grow tw-font-bold tw-text-text-primary">
              Total
            </div>
            <div className="tw-font-bold">
              {toRp(
                bills.map((i) => i.amount).reduce((a, b) => a + b, 0) +
                  (paymentMethod === "va" ? adminFee : 0) +
                  (valUangSaku === ""
                    ? 0
                    : parseInt(valUangSaku.replace(/\D/g, ""))) +
                  billZiswaf.map((i) => i.nominal).reduce((a, b) => a + b, 0),
              )}
            </div>
          </div>
          <div className="tw-my-3 divider"></div>
          <Button
            type="primary"
            loading={isPendingPaymentVa || isPendingPaymentZiswafVa}
            className="tw-h-10 tw-w-full tw-text-base tw-rounded-xl bg-gradient tw-text-background-200 focus:tw-shadow-none hover:tw-bg-background-200 hover:tw-text-accent-primary hover:tw-border-primary"
            onClick={onConfirmPayment}
          >
            Konfirmasi Bayar (
            {toRp(
              bills.map((i) => i.amount).reduce((a, b) => a + b, 0) +
                (paymentMethod === "va" ? adminFee : 0) +
                (valUangSaku === ""
                  ? 0
                  : parseInt(valUangSaku.replace(/\D/g, ""))) +
                billZiswaf.map((i) => i.nominal).reduce((a, b) => a + b, 0),
            )}
            )
          </Button>
        </>
      </PopupCustom>

      <PopupSuccess
        open={popupSuccess}
        title="Berhasil!"
        message={
          paymentMethod === "va"
            ? "Permintaan Virtual Account (VA) Berhasil!"
            : "Anda telah melakukan pembayaran melalui UANGSAKU"
        }
        textConfirm={
          paymentMethod === "va" ? "Lihat Detail" : "Riwayat Uang Saku"
        }
        onConfirm={() =>
          paymentMethod === "va"
            ? navigate(linkPage.VA_DETAIL_PAGE, {
                replace: true,
                state: {
                  vaBankFee: adminFee,
                  vaBankName: tipeVa,
                  vaDateExpired: result.datetime_expired,
                  vaDatePayment: null,
                  vaName: result.customer_name,
                  vaNumber: result.virtual_account,
                  vaStatus: "PENDING",
                  vaTrxAmount: parseInt(result.trx_amount),
                  vaTrxId: result.trx_id,
                  detail: result.detail,
                  // type: rekening?.type,
                },
              })
            : navigate(linkPage.CHECKING_ACC_PAGE)
        }
      />

      <PopupError
        open={popupError}
        title="Gagal!"
        message={
          paymentMethod === "va"
            ? "selesaikan transaksi sebelumnya terlebih dahulu"
            : errorSavingMessage
        }
        textConfirm={paymentMethod === "va" ? "Cek Transaksi" : "Tutup"}
        onConfirm={() =>
          paymentMethod === "va"
            ? navigate(linkPage.VA_DATA_PAGE)
            : setPopupError(false)
        }
      />
    </>
  );
};
